import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

const moduleUtils = {
  actions,
  getters,
  mutations,
  namespaced: true,
  state: {
    customizer: {},
    randomizer: {},
    ugcentrypoint: {},
    patternmaker: {},
    customcheckerboard: {},
    publicPath: ''
  }
};

export default moduleUtils;
